import Tippy from "@tippyjs/react";
import "tippy.js/themes/light.css";
import "../SCSS/styles.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";

import DialogContent from "@mui/material/DialogContent";
import icons from "../../../Assets/Icons/icons";
import images from "../../../ImageVariables";
import { FileUploadCompTypes } from "../FileUploadTypes";
import { ActionKind } from "../../../SupplierView/SupplierViewPropsTypes";
import { EnumSurveyAnswerStatus } from "../../../Common/Enums/EnumsTypes";
import { truncateString } from "../../../Common/CommonFunctions/TruncateString";

function FileUpload({
  reducerState,
  dispatch,
  isPreview,
  surveyAnswersInfo,
  questionId,
  removeAttachedFile,
  surveyAnswers,
}: FileUploadCompTypes) {
  return (
    <div className="file-upload-container">
      <Tippy
        content=" Please add if any files to particular question."
        placement="top-start"
        theme="light"
        disabled={
          isPreview ||
          surveyAnswersInfo.surveyStatus === EnumSurveyAnswerStatus?.COMPLETED
        }
      >
        <div className="file-attachment-cover">
          <>
            <button
              className="file-attachment-gray"
              onClick={() =>
                dispatch({
                  type: ActionKind.OPEN_FILE_UPLOAD_MODAL,
                  payload: {
                    toggleState: true,
                    questionId: questionId,
                  },
                })
              }
              disabled={
                isPreview ||
                surveyAnswersInfo.surveyStatus ===
                  EnumSurveyAnswerStatus?.COMPLETED ||
                surveyAnswers?.[questionId]?.notApplicableInfo?.isNotApplicable
              }
            >
              Attach File{" "}
              {reducerState?.uploadedFiles?.get(questionId)!?.selectedFiles
                ?.length > 0 && (
                <div className="file-total-count">
                  {
                    reducerState?.uploadedFiles?.get(questionId)!?.selectedFiles
                      ?.length
                  }
                </div>
              )}
            </button>
          </>
        </div>
      </Tippy>
      {reducerState.fileUploadModal && (
        <Dialog
          open={reducerState.fileUploadModal}
          className="file-upload-attachment-add-section-modal"
          onClose={() =>
            dispatch({
              type: ActionKind.OPEN_FILE_UPLOAD_MODAL,
              payload: {
                toggleState: false,
              },
            })
          }
          aria-labelledby="form-dalog-title"
          PaperProps={{
            style: {
              width: "453px",
              height: "452px",
            },
          }}
        >
          <DialogTitle className="file-upload-attachment-dialog-header">
            <div className="file-upload-attachment-add-modal-title-conatiner">
              <h4>Attachment</h4>
              <span
                className="attachments-close"
                onClick={() =>
                  dispatch({
                    type: ActionKind.OPEN_FILE_UPLOAD_MODAL,
                    payload: {
                      toggleState: false,
                    },
                  })
                }
              >
                {icons.cross}
              </span>
            </div>
          </DialogTitle>
          <DialogContent className="file-upload-attachments-dialog-content-conatiner">
            <div className="file-upload-attachments-modal-content-wrapper">
              <div className="file-upload-attachments-modal-left-main-cover">
                <div className="file-upload-attachments-input-cover">
                  <input
                    type="file"
                    className="file-input"
                    id="file-upload"
                    multiple
                    style={{ display: "none" }}
                    onChange={(event) =>
                      !isPreview &&
                      surveyAnswersInfo.surveyStatus !==
                        EnumSurveyAnswerStatus?.COMPLETED &&
                      dispatch({
                        type: ActionKind.HANDLE_FILE_CHANGE_FOR_FILE_UPLOAD,
                        payload: {
                          files: event.currentTarget.files,
                          fileLimit:
                            surveyAnswersInfo.surveyInfo.questionsInfo
                              .questionObj[questionId].fileInfo.fileLimit,
                          maxFileSize:
                            surveyAnswersInfo.surveyInfo.questionsInfo
                              .questionObj[questionId].fileInfo.maxFileSize,
                          questionId: questionId,
                        },
                      })
                    }
                    disabled={
                      isPreview ||
                      surveyAnswersInfo.surveyStatus ===
                        EnumSurveyAnswerStatus?.COMPLETED
                    }
                  />
                </div>
                <div className="file-upload-attachment-label-cover">
                  <label htmlFor="file-upload" className="file-upload-label">
                    <div className="upload-image">
                      <img
                        className="cloud-upload-file"
                        src={images.responseUpload}
                        alt="cloud-upload"
                      />
                    </div>
                    <div className="upload-content">Browse file </div>
                  </label>
                </div>

                <div className="file-upload-attachment-left-added-file-cover">
                  {reducerState?.uploadedFiles?.get(
                    reducerState.fileUploadQuestionId
                  )?.selectedFiles?.length! > 0 ||
                  reducerState.maxFileSizeExceededNames?.get(
                    reducerState.fileUploadQuestionId
                  )!?.size ? (
                    <div className="file-uploaded-files-added-left-cover">
                      <div className="left-uploaded">
                        {reducerState?.uploadedFiles
                          ?.get(reducerState.fileUploadQuestionId)!
                          ?.selectedFiles.map(
                            (addedData: any, index: number) => (
                              <div key={index} className="uploaded-files">
                                <Tippy
                                  content={
                                    <>
                                      <div>File name:</div>
                                      <span>{addedData?.name}</span>
                                    </>
                                  }
                                  disabled={addedData?.name?.length < 29}
                                  theme={"light"}
                                >
                                  <div className="files">
                                    {truncateString(addedData?.name, 30)} &nbsp;{" "}
                                    <span style={{ color: "#858585" }}>
                                      ({(addedData?.size / 1024).toFixed(2)}
                                      KB)
                                    </span>
                                  </div>
                                </Tippy>

                                <div
                                  className="cancel-button"
                                  onClick={() => {
                                    dispatch({
                                      type: ActionKind.REMOVE_ADDED_FILES_FOR_FILE_UPLOAD,
                                      payload: addedData.name,
                                    });
                                  }}
                                >
                                  <img src={images.UploadClear} />
                                </div>
                              </div>
                            )
                          )}
                      </div>
                    </div>
                  ) : (
                    <div className="file-upload-left-no-files-added">
                      <div>
                        <img src={images.attachmentUpload} />
                      </div>
                      <div> No files attached</div>
                    </div>
                  )}
                </div>
              </div>
              {reducerState.maxFileSizeExceededNames?.has(
                reducerState.fileUploadQuestionId
              ) &&
                reducerState.maxFileSizeExceededNames?.get(
                  reducerState.fileUploadQuestionId
                )!.size > 0 && (
                  <div>
                    {[
                      ...reducerState.maxFileSizeExceededNames?.get(
                        reducerState.fileUploadQuestionId
                      )!,
                    ].map((element) => {
                      return (
                        <>
                          <li style={{ fontSize: "14px", fontWeight: 400 }}>
                            <span
                              style={{
                                color: "red",
                              }}
                            >
                              {element}
                            </span>
                          </li>
                        </>
                      );
                    })}
                    <span style={{ fontSize: "13px", fontWeight: 400 }}>
                      {` ${
                        reducerState.maxFileSizeExceededNames?.get(
                          reducerState.fileUploadQuestionId
                        )!.size > 1
                          ? "have"
                          : "has"
                      } exceeded the max limit of ${
                        surveyAnswersInfo.surveyInfo.questionsInfo.questionObj[
                          questionId
                        ].fileInfo.maxFileSize
                      } `}
                      MB
                    </span>
                  </div>
                )}
            </div>
          </DialogContent>
          <DialogActions className="file-upload-attachments-dialog-action-conatiner-cover">
            <div className="file-upload-attachments-dialog-action-conatiner-wrapper">
              <button
                className={"cancel-btn-submission blue"}
                onClick={() =>
                  dispatch({
                    type: ActionKind.OPEN_FILE_UPLOAD_MODAL,
                    payload: {
                      toggleState: false,
                    },
                  })
                }
              >
                Cancel
              </button>
              <button
                className={"add-btn-submission blue"}
                onClick={() =>
                  dispatch({
                    type: ActionKind.OPEN_FILE_UPLOAD_MODAL,
                    payload: {
                      toggleState: false,
                    },
                  })
                }
              >
                Add
              </button>
            </div>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}

export default FileUpload;
